import React from 'react'
import { Link } from 'gatsby'
import logo from '../img/LOGO_F.svg'

const Navbar = class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      active: false,
      navBarActiveClass: '',
    }
  }

  toggleHamburger = () => {
    // toggle the active boolean in the state
    this.setState(
      {
        active: !this.state.active,
      },
      // after state has been updated,
      () => {
        // set the class in state for the navbar accordingly
        this.state.active
          ? this.setState({
            navBarActiveClass: 'is-active',
          })
          : this.setState({
            navBarActiveClass: '',
          })
      }
    )
  }

  render() {
    return (
      <nav
        className="navbar is-transparent"
        role="navigation"
        aria-label="main-navigation"
      >
        <div className="container is-fluid">
          <div className="navbar-brand custom-style">
            <Link to="/" className="navbar-item" title="Logo">
              <img src={logo} alt="Jan Všetečka" style={{ height: '60px', maxHeight: '60px' }}/>
            </Link>
            {/* Hamburger menu */}
            <button
              className={`navbar-burger burger ${this.state.navBarActiveClass}`}
              data-target="navMenu"
              onClick={() => this.toggleHamburger()}
            >
              <span/>
              <span/>
              <span/>
            </button>
          </div>
          <div
            id="navMenu"
            className={`navbar-menu is-marginless ${this.state.navBarActiveClass}`}
          >
            {/*<div className="navbar-start">*/}
              {/*<a href="/" class="navbar-item">asd</a>*/}
            {/*</div>*/}

            <div className="navbar-end has-text-centered is-size-4-tablet has-text-weight-bold">
              <Link className="navbar-item" to="/">
                Úvod
              </Link>
              {/*<Link className="navbar-item" to="/services">*/}
              {/*  Služby*/}
              {/*</Link>*/}
              <Link className="navbar-item" to="/realizace">
                Realizace
              </Link>
              <Link className="navbar-item" to="/kontakt">
                Kontakt
              </Link>
            </div>
          </div>
        </div>
      </nav>
    )
  }
}

export default Navbar
